import { useState } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';

import TableOptions from '../tableOptions';
import MaskTable from '../maskTable';
import TabAbout from '../tabAbout';
// import TextareaData from '../textareadata';
import TabControl from '../tabControl';
import InterfaceSwitcher from '../interfaceSwitcher';
import AppConfig from '../../services/appConfig';

import './navMenu.css';

function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`wpglobus-to-tabpanel-${index}`}
      aria-labelledby={`vertical-wpglobus-to-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography component="div">{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
		height: '100%'
  },
	optionsBox: {
		height: '400px',
		width: '300px',
		float: 'left'
	},
	appBar: {
		backgroundColor: '#00c8f4', // #d3e4f4, '#d3e4f4', #a9b6c2, 
		color: '#000',
		width: '15%'
	},
	tabWrapper: {
		'&:hover': {
      backgroundColor: '#ffffff',
    }
	},
	tabSelected: {
		fontWeight: '600',
		'&:hover': {
      backgroundColor: '#d3e4f4',
    }		
	},
	tabHidden: {
		display: 'none'
	},
	tabsPanelWrapper: {
		display: 'flex'
	},
	tabsPanels70: {
		width: '70%'
	},
	tabsPanels80: {
		width: '80%'
	}
}));

function a11yProps(index) {
  return {
    id: `wpglobus-to-tab-${index}`,
    'aria-controls': `vertical-wpglobus-to-tabpanel-${index}`,
  };
}

function getHashKeyByValue(object, value) {
	for (var prop in object) {
		if (object.hasOwnProperty(prop)) {
			if (object[prop] === value) {
				return prop*1;
			}
		}
	}
	return 0*1;
}
	
export default function NavMenu() {
	
	const hash = {
		0:'#about',
		1:'#translate',
		2:'#allOptions',
		3:'#masks',
		4:'#control',
		5:'#interfaceV1'
	}
	
  const classes = useStyles();
  const [value, setValue] = useState( getHashKeyByValue( hash, window.location.hash ) );
	const config = AppConfig();

	const getTabPanelClasses = (index) => {
		return 'wpglobus-to-tabpanel wpglobus-to-tabpanel-'+index+' wpglobus-to-tabpanel-'+hash[index].replace('#','')
	}
	const getTabPanelWrapperClasses = (index) => index === 3 ? classes.tabsPanels80 : classes.tabsPanels70
	
	const isTabDisabled = (tab) => {
		let disabled = false;
		if ( tab === 'tabMasks' || tab === 'tabControl' ) {
			disabled = true;
		}
		return ( disabled && ! config.debug ) ? true : false
	}
	
	const getTabClasses = (index, tab='') => {
		let tabClasses = classes.tabWrapper;
		if ( index === value ) {
			tabClasses = classes.tabWrapper + ' ' + classes.tabSelected;
		}
		
		tabClasses = tabClasses  + ' wpglobus-to-tab-'+hash[index].replace('#','');
		
		if ( tab !== '' && isTabDisabled(tab) ) {
			tabClasses = tabClasses + ' ' + classes.tabHidden;
		}
		return tabClasses;
	}

  const handleChange = (event, newValue) => {
    setValue(newValue);
		var newUrl = window.location.protocol + "//" + window.location.host + window.location.pathname + window.location.search + hash[newValue];
		window.history.pushState(
			{
				path:newUrl
			},
			'',
			newUrl
		);
  };

  return (
    <div className={classes.root}>
			<div className={classes.tabsPanelWrapper}>
				<AppBar position="static" className={classes.appBar}>
					<Tabs value={value} onChange={handleChange} aria-label="vertical-wpglobus-to-tabs tabs" orientation="vertical" indicatorColor="secondary">
						<Tab 
							label="About" 
							{...a11yProps(0)} 
							className={ getTabClasses(0) } 
						/>
						<Tab 
							label="Options to translate" 
							{...a11yProps(1)}
							className={ getTabClasses(1) } 
						/>
						<Tab 
							label="All options" 
							{...a11yProps(2)} 
							className={ getTabClasses(2) } 
						/>
						<Tab 
							label="Masks" 
							{...a11yProps(3)} 
							disabled={isTabDisabled('tabMasks')} 
							className={ getTabClasses(3, 'tabMasks' ) } 
						/>
						<Tab 
							label="Control tab" 
							{...a11yProps(4)} 
							disabled={isTabDisabled('tabControl')} 
							className={ getTabClasses(4, 'tabControl' ) } 
						/>
						<Tab 
							label="Interface v.1" 
							{...a11yProps(5)} 
							disabled={isTabDisabled('tabOldInterface')} 
							className={ getTabClasses(5) } 
						/>
					</Tabs>
				</AppBar>
				<div className={ getTabPanelWrapperClasses(value) }>
					<TabPanel value={value} index={0} className={ getTabPanelClasses(0) }>
						<TabAbout />
					</TabPanel>			
					<TabPanel value={value} index={1} className={ getTabPanelClasses(1) }>
						<TableOptions config={config} endpoint={'optionsToTranslate'} />
					</TabPanel>
					<TabPanel value={value} index={2} className={ getTabPanelClasses(2) }>
						<TableOptions config={config} endpoint={'allOptions'} />
					</TabPanel>
					<TabPanel value={value} index={3} className={ getTabPanelClasses(3) }>
						<MaskTable config={config} endpoint={'getMasks'} />
					</TabPanel>
					<TabPanel value={value} index={4} className={ getTabPanelClasses(4) }>
						<TabControl className={classes.optionsBox} />
					</TabPanel>
					<TabPanel value={value} index={5} className={ getTabPanelClasses(5) }>
						<InterfaceSwitcher 
							className={classes.optionsBox} 
							interfaceVersion={config.interfaceVersion} 
							optionKey={'interface_version_key'} 
							mode={config.mode} />
					</TabPanel>				
				</div>
			</div>
    </div>
  );
}
